// JOBE-0044.4: groupLabel(ts, now) — pure function mapping a timestamp
// to its date-bucket label per umbrella §R2. Used to insert
// <GroupDivider> rows into the list at each label transition.
//
// Buckets (in priority order):
//   Today                — same calendar day as `now`
//   Yesterday            — calendar day - 1
//   Earlier this week    — same ISO week, not Today/Yesterday
//   Last week            — ISO week - 1
//   Earlier this month   — same calendar month, before "Last week"
//   Earlier              — older than this month

function sameCalendarDay(a, b) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

// startOfDay returns midnight of the given Date.
function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

// isoWeekStart returns the Monday-midnight starting the ISO week of d.
function isoWeekStart(d) {
  const x = startOfDay(d);
  // getDay: Sun=0..Sat=6. ISO week starts Monday → offset to subtract.
  const dow = x.getDay();
  const offset = (dow === 0 ? 6 : dow - 1);
  x.setDate(x.getDate() - offset);
  return x;
}

export function groupLabel(ts, now) {
  if (!ts) return 'Earlier';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return 'Earlier';
  const nowDate = now instanceof Date ? now : new Date(now);

  if (sameCalendarDay(d, nowDate)) return 'Today';

  const yesterday = new Date(nowDate);
  yesterday.setDate(yesterday.getDate() - 1);
  if (sameCalendarDay(d, yesterday)) return 'Yesterday';

  const thisWeekStart = isoWeekStart(nowDate);
  const lastWeekStart = new Date(thisWeekStart);
  lastWeekStart.setDate(lastWeekStart.getDate() - 7);

  if (d >= thisWeekStart && d < startOfDay(yesterday)) {
    return 'Earlier this week';
  }
  if (d >= lastWeekStart && d < thisWeekStart) {
    return 'Last week';
  }

  if (
    d.getFullYear() === nowDate.getFullYear() &&
    d.getMonth() === nowDate.getMonth() &&
    d < lastWeekStart
  ) {
    return 'Earlier this month';
  }

  return 'Earlier';
}
